import React, { useEffect } from 'react'
import { useConcursoTikTok } from '../../../../hooks/useConcursoTikTok2025';

const Integrantes = () => {

    const { integrantes, getIntegrantes} = useConcursoTikTok();

    useEffect(() => {
        getIntegrantes(2026)
        console.log(integrantes);
        
    }, [])

    if(integrantes && integrantes[0]){
        return (
            <div className="container-fluid section-home" id="videos">
                <div className="col-12 anchor-section"></div>
                <div className="row justify-content-center">
                    <div className="col-md-8 inner-sections">
                        <div className="title-tiktok-info">
                            <h2>Integrantes del Jurado Calificador</h2>
                        </div>
                        <div className="container-inner-info p-4">       
                        <div className="paragraph_content" dangerouslySetInnerHTML={{__html: `${integrantes[0]?.texto}` }}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }else{
        return(<></>);
    
    }
}

export default Integrantes
